import React from "react";
import axios from "axios";
import { useSelector } from "react-redux";

export default function () {
  const token = useSelector(state => state.token);

  axios.defaults.baseURL = process.env.REACT_APP_API_URL;

  if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  }

  // Add a 401 response interceptor
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (401 === error.response.status) {
      axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
      axios.post('/logout')
        .then(
          localStorage.removeItem('persist:root'),
          window.location.href = "/login"
        );
    } else {
      return Promise.reject(error);
    }
  });

  return (
    <>
    </>
  );
}